import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./index.css";
import SinglePageAppLink from "../../SinglePageAppLink";

const Pill = ({ friendlyName, linkUrl, isHighlighted }) => {
  const classNames = classnames(styles.pill, {
    [styles.highlightedCategory]: isHighlighted,
  });

  return (
    <li>
      {isHighlighted ? (
        <span className={classNames} aria-label={friendlyName}>
          {friendlyName}{" "}
        </span>
      ) : (
        <SinglePageAppLink href={linkUrl} className={classNames}>
          {friendlyName}
        </SinglePageAppLink>
      )}
    </li>
  );
};

Pill.propTypes = {
  friendlyName: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool,
};

export default Pill;
